import {
    COMMIT_CHANGE_FORGOT_PASSWORD_MODAL,
    COMMIT_CHANGE_LOGIN_MODAL,
    COMMIT_CHANGE_REGISTER_MODAL
} from "@constants/mutation-type/login-mutation-type";
import {COMMIT_CHANGE_SIDEBAR_SHOW} from "@constants/mutation-type";

export default {
    computed: {
        isLogin() {
            return this.$store.state.login.isLogin
        },
        showSidebar() {
            return this.$store.state.showSidebar
        },
        isMobile() {
            return this.$store.state.isMobile
        },
        isMobileScreen() {
            return this.$store.state.isMobileScreen
        },
        isMember(){
            console.log(this.$store.state.login.userInfo.memberFlag)
            return this.$store.state.login.userInfo.memberFlag != 0
        },
    },
    methods: {
        isLoginClick() {
            if (this.isLogin) {
                return true
            } else {
                this.$store.commit(COMMIT_CHANGE_LOGIN_MODAL, {
                    showLoginModal: true
                });
                return false;
            }
        },
        changeShowSidebar(showSidebar) {
            this.$store.commit({
                type: COMMIT_CHANGE_SIDEBAR_SHOW,
                showSidebar
            })
        },
        _changeLoginModal(showLoginModal) {
            // 关闭注册
            this.$store.commit(COMMIT_CHANGE_REGISTER_MODAL, {
                showLoginModal: false
            });
            // 关闭忘记密码
            this.$store.commit(COMMIT_CHANGE_FORGOT_PASSWORD_MODAL, {
                showForgotPasswordModal: false
            });
            this.$store.commit(COMMIT_CHANGE_LOGIN_MODAL, {
                showLoginModal
            })
        },
        _changeRegisterModal(showRegisterModal) {
            // 关闭登录
            this.$store.commit(COMMIT_CHANGE_LOGIN_MODAL, {
                showLoginModal: false
            });
            // 关闭忘记密码
            this.$store.commit(COMMIT_CHANGE_FORGOT_PASSWORD_MODAL, {
                showForgotPasswordModal: false
            });
            this.$store.commit(COMMIT_CHANGE_REGISTER_MODAL, {
                showRegisterModal
            })
        },
        _changeForgotPasswordModal(showForgotPasswordModal) {
            // 关闭登录
            if (showForgotPasswordModal) {
                this.$store.commit(COMMIT_CHANGE_LOGIN_MODAL, {
                    showLoginModal: false
                });
            }
            this.$store.commit(COMMIT_CHANGE_FORGOT_PASSWORD_MODAL, {
                showForgotPasswordModal
            })
        }
    }
}
